import { ErrorType } from './types';

export const renderError = (error: ErrorType): string | null | boolean => {
  if (!error.value) {
    return null;
  }

  if (!error.text || error.text.length === 0) {
    return true;
  }

  if (Array.isArray(error.text) && error.text.every((t) => t.length === 0)) {
    return true;
  }

  return Array.isArray(error.text) ? error.text[0] : error.text;
};
